<div class="container" >

  <div class="top">
    <div *ngIf="type !== skeletonOptions.GENERAL" class="skeleton-img"></div>
    <div class="skeleton-name" [ngClass]="{'full-length': type === skeletonOptions.GENERAL}"></div>
  </div>

  <div class="body" >
    <div class="skeleton-text"></div>
    <div class="skeleton-text"></div>
    <div class="skeleton-text"></div>
    <div *ngIf="type === skeletonOptions.GENERAL" class="skeleton-text"></div>

  </div>
</div>
